type NextInvoice = {
  totalAmount: number
  taxAmount: number
  currency: string
} | null

const numberWithCurrency = (amount: number, currency: string): string => {
  const locale = typeof navigator !== 'undefined' ? navigator.language : 'en-US'
  return amount.toLocaleString(locale, {
    style: 'currency',
    currency: currency.toUpperCase(),
  })
}

/**
 * Formats the upcoming invoice amount from a WebBillingDetails NextInvoice.
 * NextInvoice amounts are in cents; this util returns the raw total in dollars
 * so it can be passed to `formatPriceSimple` (which expects dollars).
 */
export const getUpcomingInvoiceCopy = (
  nextInvoice: NextInvoice,
): {
  hasUpcomingInvoice: boolean
  upcomingInvoiceAmount: string
  upcomingInvoiceAmountRaw: number
} => {
  if (!nextInvoice) {
    return {
      hasUpcomingInvoice: false,
      upcomingInvoiceAmount: '$0.00',
      upcomingInvoiceAmountRaw: 0,
    }
  }

  const totalAmountDollars = nextInvoice.totalAmount / 100

  return {
    hasUpcomingInvoice: true,
    upcomingInvoiceAmount: numberWithCurrency(
      totalAmountDollars,
      nextInvoice.currency,
    ),
    upcomingInvoiceAmountRaw: totalAmountDollars,
  }
}
